import {
  List,
  Datagrid,
  NumberField,
  DateField,
  FunctionField,
  ReferenceInput,
  Filter,
  AutocompleteInput,
  ReferenceField,
} from "react-admin";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

const createdFromChoises = [
  { id: "MANUALLY_ADMIN", name: "Administrateur" },
  { id: "MANUALLY_CLIENT", name: "Client" },
  { id: "ORDER", name: "Bon de commande" },
];

const createdFromLabels: Record<string, string> = createdFromChoises.reduce(
  (acc, { id, name }) => ({ ...acc, [id]: name }),
  {}
);

const ClientInventoryFilter: React.FC = (props) => (
  <Filter {...props}>
    <ReferenceInput
      source="client"
      reference="clients"
      label="Client"
      perPage={50}
    >
      <AutocompleteInput
        optionText={(record) => `${record.internalCode} - ${record.name}`}
        fullWidth
        label="Client"
        filterToQuery={(searchText: any) => ({
          filterTree: {
            operator: "or",
            operands: [
              {
                term: {
                  name: "name",
                  filterType: "like",
                  value: searchText,
                },
              },
              {
                term: {
                  name: "internalCode",
                  filterType: "like",
                  value: searchText,
                },
              },
            ],
          },
        })}
      />
    </ReferenceInput>
  </Filter>
);

export const ClientInventoryList: React.FC = (props) => {
  return (
    <List
      {...props}
      resource="client-inventory"
      sort={{ field: "createdAt", order: "DESC" }}
      filters={<ClientInventoryFilter />}
      title="Inventaire des clients"
    >
      <Datagrid>
        <ReferenceField
          label="Client"
          source="client"
          reference="clients"
          link={false}
        >
          <FunctionField render={(record) => record.name} />
        </ReferenceField>
        <NumberField source="airbagsCount" label="Nb airbag" />
        <NumberField source="fullBinsCount" label="Caisses pleines" />
        <NumberField source="emptyBinsCount" label="Caisses vides" />
        <DateField
          source="createdAt"
          label="Date création"
          locales="fr-FR"
          options={{
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }}
        />
        <FunctionField
          source="createdFrom"
          label="Ajouté par"
          render={(record) =>
            createdFromLabels[record.createdFrom] || record.createdFrom
          }
        />
        <FunctionField
          label="Inventaire"
          render={(record) => (
            <Button
              component={Link}
              to={`/client-inventory/details/${record.client}`}
              variant="outlined"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              Voir
            </Button>
          )}
        />
      </Datagrid>
    </List>
  );
};
